import React from 'react'
import { component_tool } from '@/tool'
const { WizLocationSelect } = component_tool
import { WizTableForm } from '../../../common'
const userConfig = WizTableForm.Config.user(this, { apiParams: { state: 1 } })

export const createColumns = (self, { record, dict }) => {
  return [
    {
      name: 'id',
      formItem: {
        type: 'hidden'
      }
    },
    {
      title: '教室名称',
      name: 'name',
      dataIndex: 'name',
      formItem: {
        maxlength: 30,
        placeholder: '教室名称最多输入30个字',
        rules: [{ required: true, message: '请输入教室名称' }]
      }
    },
    {
      title: '教室编号',
      name: 'code',
      dataIndex: 'code',
      formItem: {
        maxlength: 50,
        placeholder: '教室编号最多输入50个字',
        rules: [{ required: true, message: '请输入教室编号' }]
      }
    },
    {
      title: '培训中心',
      name: 'trainCenterId',
      dataIndex: 'trainCenterId',
      dict: dict,
      formItem: {
        type: 'select',
        rules: [{ required: true, message: '请选择培训中心' }]
      }
    },
    {
      title: '城市',
      name: 'city',
      dataIndex: 'city',
      formItem: {
        type: 'diy',
        diy: WizLocationSelect,
        rules: [{ required: true, message: '请选择城市' }]
      }
    },
    {
      title: '教室类型',
      name: 'type',
      dataIndex: 'type',
      dict: [
        { code: 0, codeName: '普通教室' },
        { code: 1, codeName: '进车' },
        { code: 2, codeName: '模拟展厅' },
        { code: 3, codeName: '技术银级认证教室' },
        { code: 4, codeName: '技术铜级认证教室' },
        { code: 5, codeName: '技术IBT教室' },
        { code: 6, codeName: '技术ILT实操教室' },
        { code: 7, codeName: '培训教室' },
        { code: 8, codeName: '电脑教室' },
        { code: 9, codeName: '多功能教室' },
        { code: 10, codeName: '二手车培训教室' },
        { code: 11, codeName: '技术培训教室' },
        { code: 12, codeName: '绕车演练场地' },
        { code: 13, codeName: '技术实操教室' },
        { code: 14, codeName: '多功能培训教室' },
        { code: 15, codeName: '多功能会议室' }
      ],
      formItem: {
        type: 'select',
        rules: [{ required: true, message: '请选择教室用途' }]
      }
    },
    {
      title: '教室用途',
      name: 'purpose',
      dataIndex: 'purpose',
      dict: [
        { code: 0, codeName: '不限制' },
        { code: 1, codeName: '新产品培训' },
        { code: 2, codeName: '实操培训' },
        { code: 3, codeName: '岗位培训' },
        { code: 4, codeName: '区域会议' }
      ],
      formItem: {
        type: 'select',
        rules: [{ required: true, message: '请选择教室用途' }]
      }
    },
    {
      title: '进车(数量)',
      name: 'parkingSpace',
      dataIndex: 'parkingSpace',
      formItem: {}
    },
    {
      title: '座位(数量)',
      name: 'seat',
      dataIndex: 'seat',
      formItem: {}
    },
    {
      title: '教室面积㎡',
      name: 'floorSpace',
      dataIndex: 'floorSpace',
      formItem: {}
    },
    {
      title: '教室地址',
      name: 'address',
      dataIndex: 'address',
      formItem: {}
    },
    {
      title: '教室配置',
      name: 'fixedEquipments',
      dataIndex: 'fixedEquipments',
      dict: [
        { code: 0, codeName: '投影仪' },
        { code: 1, codeName: '培训器具' },
        { code: 2, codeName: '笔记本电脑' },
        { code: 3, codeName: '灯具' },
        { code: 4, codeName: '举升机' }
      ],
      formItem: {
        type: 'checkbox'
      }
    },
    {
      title: '教室管理员',
      name: 'personIds',
      dataIndex: 'personIds',
      formItem: {
        diy: WizTableForm,
        ...userConfig,
        initRows: record && record.personInfoList ? record.personInfoList : [],
        rules: [{ required: true, message: '请选择教室管理员' }]
      }
    },
    {
      title: '审核类型',
      name: 'auditType',
      dataIndex: 'auditType',
      dict: [
        { code: 0, codeName: '自动审核' },
        { code: 1, codeName: '手动审核' }
      ],
      formItem: {
        type: 'select',
        rules: [{ required: true, message: '请选择审核类型' }]
      }
    },
    {
      title: '教室状态',
      name: 'status',
      dict: [
        { code: 0, codeName: '正常' },
        { code: 1, codeName: '停止使用' },
        { code: 2, codeName: '维修中' }
      ],
      formItem: {
        type: 'select',
        rules: [{ required: true, message: '请选择教室状态' }]
      }
    },
    {
      title: '备注',
      name: 'remark',
      dataIndex: 'remark',
      formItem: {}
    }
  ]
}